export default __webpack_public_path__ + "static/media/click.d1c5cc97.wav";